module.exports = __webpack_public_path__ + "static/pendulum-d069348f01758d5d3dcdaeb04871a32e.jpg";